module.exports = __webpack_public_path__ + "img/ESPORT LOGO_1.jpg";